import { getInitialStateFromConfig } from "helpers/form";

const config = {
    daysBeforeClosingDocumentAssignments: {
        // field
        label: "Срок автоматического закрытия задачи по сдаче документов (дней)",
        inputProps: {
            name: "daysBeforeClosingDocumentAssignments",
            type: "number",
            placeholder: "1-10",
            min: 1,
            max: 10,
        },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
